<template>
  <div class="activityDetail" v-if="!showLoad">
    <div class="header">
      <h4>{{baseData.title}}</h4>
      <p class="clearfix">
        <span class="fl">{{baseData.startTime}}</span>
        <span class="fr">
          阅读
          <em>{{baseData.viewCount}}</em>
        </span>
      </p>
    </div>
    <div class="activityInfo">
      <p v-html="baseData.intro"></p>
    </div>
    <div class="BtnBox clearfix">
      <span class="fl">
        已报名：
        <em>{{baseData.collectCount}}人</em>
        <!-- <i>&rsaquo;</i> -->
      </span>

      <van-button
        type="primary"
        v-if="Btnloading"
        :class="['btn','fr',applyType == true?'':'noneStyle']"
        @click="saveApply"
        :loading="applyLoading"
        :loading-text="loadingText"
      >{{penyText}}</van-button>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "activityDetail",
  data() {
    return {
      baseData: {}, //数据源
      applyData: {
        id: "",
        orgId: "",
        uid: "",
      },
      applyLoading: false,
      applyType: false,
      Btnloading: false,
      loadingText: "操作中...",
      penyText: "",
      errMsg: "已报名，请不要重复报名",
    };
  },
  mounted() {
    document.title = "活动详情";
    this.applyData.id = this.$route.query.commonId; //活动Id
    this.applyData.orgId = this.$route.query.orgId; //机构Id
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad", "setAppData"]),
    initPage() {
      if (this.userinfo && this.userinfo.id) {
        this.applyData.uid = this.userinfo.id;
        this.getMainDetail();
      }
    },
    getMainDetail() {
      let _this = this;
      this.setShowLoad(false);
      _this.$api.activity.player
        .activityDetails(_this.applyData)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            if (res.data.isSignUp) {
              _this.penyText = "已报名";
              _this.applyType = false;
             
            } else {
              _this.penyText = "未报名";
              // _this.addActivityAnswer();
            }
            _this.addActivityAnswer();
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    addActivityAnswer() {
      let _this = this;
      let data = {
        activityId: _this.applyData.id,
        openId: null,
        uid: _this.applyData.uid,
      };

      _this.$api.activity.player
        .addActivityAnswer(data)
        .then((res) => {
          if (res.code == "1") {
            if (res.data == null) {
              _this.penyText = "我要报名";
              this.applyType = true;
            } else {
              this.applyType = false;
            }
          } else {
            _this.$toast(res.msg);
            _this.errMsg = res.msg;
          }
          _this.Btnloading = true;
        })
        .catch((err) => {
          console.log(err);
          _this.$toast("网络失败，请稍后重试");
        });
    },
    saveApply() {
      let _this = this;

      if (_this.applyType) {
        _this.applyLoading = true;
        let data = {
          activityId: _this.applyData.id,
          openId: null,
          uid: _this.applyData.uid,
        };

        _this.$api.activity.player
          .activitySingUp(data)
          .then((res) => {
            this.setShowLoad(false);
            if (res.code == "1") {
              _this.baseData.collectCount =
                Number(_this.baseData.collectCount) + 1;
              _this.$toast("报名成功");
              this.penyText = "已报名";
              _this.applyType = false;
            } else {
              _this.$toast(res.msg);
            }
            _this.applyLoading = false;
          })
          .catch((err) => {
            _this.applyLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      } else {
        // if()
        _this.$toast(_this.errMsg);
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function (val) {
        if (val && val.id) {
          this.applyData.uid = this.userinfo.id;
          this.getMainDetail();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.activityDetail {
  width: 100%;
  height: 100%;
  background-color: #fff;
  font-family: " PingFangSC-Medium", "PingFang SC";
  padding: 15px 15px;
  .header {
    h4 {
      height: 28px;
      font-size: 20px;
      color: #000;
      line-height: 28px;
      margin: 0 auto;
      text-align: center;
    }
    p {
      margin-top: 20px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #aaa;
      line-height: 20px;
      em {
        font-weight: normal;
      }
    }
  }
  .activityInfo {
    width: 100%;
    min-height: 200px;
    margin-top: 16px;
    font-size: 14px;
    font-weight: 500;
    color: #828282;
    line-height: 20px;

    img {
      max-width: 100%;
    }
    p {
      img {
        max-width: 100%;
      }
    }
    margin-bottom: 70px;
  }
  .BtnBox {
    width: 100%;
    height: 55px;
    position: fixed;
    left: 0;
    bottom: 0;
    border-top: 1px solid #f6f6f6;
    padding: 0 15px;
    span {
      display: block;
      height: 100%;
      line-height: 55px;
      font-size: 14px;
      font-weight: 400;
      color: #97a1ad;
      em {
        display: inline-block;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #3c78f9;
        margin-right: 6px;
        line-height: 55px;
      }
      i {
        display: inline-block;
        font-weight: normal;
        color: #3c78f9;
        font-size: 22px;
        line-height: 55px;
      }
    }
    .btn {
      display: inline-block;

      height: 38px;
      border-radius: 4px;

      margin-top: 8px;
      text-align: center;
      .van-button__text {
        color: #fff;
        font-size: 15px;
        line-height: 38px;
      }
    }
    .btn.noneStyle {
      background-color: #eee;
      border: 0 none;
      .van-button__text {
        color: #999;
      }
    }
  }
}
</style>
